<template>
    <div class="container-fluid h-100">
        <div class="content-contact" id="content-contact-id" title="Contacto Havoline MotoClub" alt="Contacto Havoline MotoClub">
            <div
                class="row jusify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-center align-items-center h-100 ">
                <div class="col-12 ">
                    <h1 class="title-contact">
                        ¿NECESITAS AYUDA?
                    </h1>
                </div>
                <div class="col-12 col-md-8 col-lg-8 col-xl-8">
                    <p class="subtitle-contact">En este club, tú eres lo más importante. Por eso, ponemos a tu
                        disposición
                        nuestros canales de contacto para ayudarte a resolver tus dudas.</p>
                </div>
                <div class="col-12 col-md-12 col-lg-9 col-xl-7">
                    <div class="row jusify-content-center">
                        <div class="col-12 col-md-6 col-lg-6 col-xl-6">
                            <div class="row pt-2 info-contact">
                                <div class="col-2 col-md-2 col-lg-2 col-xl-2">
                                    <img alt="Recurso 15" class="mt-2" width="40" src="../../assets/icon/Recurso 15.png">
                                </div>
                                <div class="col-10 col-md-10 col-lg-10 col-xl-10">
                                    <label class="text-info-contact "> 447 3910 en Bogotá |</label><br>
                                    <label class="text-info-contact pb-2">
                                        01 8000 112005 en horario hábil </label>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-6 col-xl-6">

                            <div class="row pt-2 info-contact">
                                <div class="col-2 col-md-2 col-lg-2 col-xl-2">
                                    <img alt="Recurso 16" class="mt-2" width="40" src="../../assets/icon/Recurso 16.png">
                                </div>
                                <div class="col-10 col-md-10 col-lg-10 col-xl-10">
                                    <label class="text-info-contact "> <strong>Carrera 56 No. 19 - 95</strong> |</label><br>
                                    <label class="text-info-contact pb-2">
                                        Bogotá D.C., Colombia </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-10 col-lg-8 col-xl-6">

                    <div class="row p-row mt-3">
                        <div class="col-12" style="text-align: left">
                            <small>Recuerda que los datos marcados con (*) son obligatorios</small>
                        </div>
                        <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                            <div class="form-group">
                                <div class="input-group mb-3">
                                    <input :class="{ 'is-danger': errors.name }" v-model="form.name" type="text"
                                        class="form-control color-input" aria-label="name" placeholder="Nombres *"
                                        aria-describedby="basic-addon1" />
                                </div>
                                <span v-if="errors.name"
                                    class="text-danger float-left small error-danger">{{ errors.name }}</span>
                            </div>
                        </div>
                        <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                            <div class="form-group">
                                <div class="input-group mb-3">
                                    <input :class="{ 'is-danger': errors.lastname }" v-model="form.lastname" type="text"
                                        class="form-control color-input" aria-label="lastname" placeholder="Apellidos *"
                                        aria-describedby="basic-addon1" />
                                </div>
                                <span v-if="errors.lastname"
                                    class="text-danger float-left small error-danger">{{ errors.lastname }}</span>
                            </div>
                        </div>
                        <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                            <div class="form-group">
                                <div class="input-group  mb-3">
                                    <select v-model="form.state_id" class="form-control color-input select-input"
                                        :class="{ 'is-danger': errors.state_id }" id="exampleFormControlSelect1">
                                        <option disabled value="0" selected>Departamento *</option>
                                        <option v-for="(item, i) in listDocuments" :value="item.id"
                                            class=" color-option" :key="'st' + i">{{ item.name }}
                                        </option>
                                    </select>
                                </div>
                                <span v-if="errors.state_id"
                                    class="text-danger float-left small error-danger">{{ errors.state_id }}</span>
                            </div>
                        </div>

                        <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                            <div class="form-group">
                                <div class="input-group mb-3">
                                    <select v-model="form.city_id" :disabled="showCities"
                                        class="form-control color-input select-input"
                                        :class="{ 'is-danger': errors.city_id }" id="exampleFormControlSelect1">
                                        <option value="0" disabled selected>Ciudad *</option>
                                        <option v-for="(item, i) in listCities" :key="'ci' + i" :value="item.id"
                                            class=" color-option">
                                            {{ item.name }}
                                        </option>
                                    </select>
                                </div>
                                <span v-if="errors.city_id"
                                    class="text-danger float-left small error-danger">{{ errors.city_id }}</span>
                            </div>
                        </div>
                        <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                            <div class="form-group">
                                <div class="input-group mb-3">
                                    <input :class="{ 'is-danger': errors.phone }" type="text" v-model="form.phone"
                                        class="form-control color-input" aria-label="phone" placeholder="Teléfono *"
                                        aria-describedby="basic-addon1" />
                                </div>
                                <span v-if="errors.phone"
                                    class="text-danger float-left small error-danger">{{ errors.phone }}</span>
                            </div>
                        </div>
                        <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                            <div class="form-group">
                                <div class="input-group mb-3">
                                    <input :class="{ 'is-danger': errors.email }" v-model="form.email" type="text"
                                        class="form-control color-input" aria-label="email" placeholder="Correo *"
                                        aria-describedby="basic-addon1" />
                                </div>
                                <span v-if="errors.email"
                                    class="text-danger float-left small error-danger">{{ errors.email }}</span>
                            </div>
                        </div>
                        <div class="col-12 col-md-12 col-lg-12 col-xl-12 col-sm-12">
                            <div class="form-group">
                                <div class="input-group mb-3">
                                    <textarea v-model="form.message" placeholder="Mensaje"
                                        :class="{ 'is-danger': errors.message }" class="form-control color-text"
                                        id="exampleFormControlTextarea1" rows="5"></textarea>
                                </div>
                                <span v-if="errors.message"
                                    class="text-danger float-left small error-danger">{{ errors.message }}</span>
                            </div>
                        </div>
                        <div class="col-12 col-md-12 col-lg-12 col-xl-12 col-sm-12">
                            <button :disabled="disableLoading" type="button" @click="send()"
                                class="btn btn-danger btn-sm btn-block btn-register" id="btn-register-id">
                                <span v-if="disableLoading" class="spinner-border spinner-border-md" role="status"
                                    aria-hidden="true"></span>
                                <template v-else>Enviar</template>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            disableLoading: false,
            listDocuments: [],
            listCities: [],
            showCities: true,
            form: {
                state_id: 0,
                city_id: 0,
                name: "",
                lastname: "",
                phone: "",
                email: "",
                message: ""
            },
            errors: {
                state_id: false,
                city_id: false,
                name: false,
                lastname: false,
                phone: false,
                email: false,
                message: false
            },
        }
    },

    methods: {
        validform() {
            let app = this;

            if (!app.form.name) {
                app.errors.name = "Los nombres son requeridos.";
                return false;
            }
            if (!app.form.lastname) {
                app.errors.lastname = "Los apellidos son requeridos.";
                return false;
            }
            if (!app.form.state_id) {
                app.errors.state_id = "El departamento es requerido.";
                return false;
            }
            if (!app.form.city_id) {
                app.errors.city_id = "La ciudad es requerida.";
                return false;
            }
            if (!app.form.phone) {
                app.errors.phone = "El número de teléfono es requerido.";
                return false;
            }
            if (!app.form.email) {
                app.errors.email = "El email es requerido.";
                return false;
            }
            if (!app.form.message) {
                app.errors.message = "El mensaje es requerido.";
                return false;
            }

            if (
                !app.errors.state_id &&
                !app.errors.city_id &&
                !app.errors.name &&
                !app.errors.lastname &&
                !app.errors.phone &&
                !app.errors.email &&
                !app.errors.message &&
                !app.validEmail(app.errors.email) &&
                !app.validPhone(app.errors.phone)
            ) {
                return true;
            }

            return false;
        },
        send() {
            // console.log(this.form)
            this.disableLoading = true;
            if (this.validform()) {
                axios.post("api/contact", this.form).then(res => {
                    // console.log(JSON.stringify(res));
                    if (res.data.cod == 0) {
                        this.clearForm();
                        this.$swal({
                            confirmButtonColor: "#dc3545",
                            icon: "success",
                            title: "Muy bien",
                            text: res.data.data
                        }).then((result) => {
                            if(result.isConfirmed){
                                this.$router.push({ name: "home" });
                            }
                        });
                    }
                    this.disableLoading = false;
                }).catch(() => {
                    this.disableLoading = false;
                });
            } else {
                this.disableLoading = false;
            }
        },
        clearForm(){
            this.form = {
                state_id: 0,
                city_id: 0,
                name: "",
                lastname: "",
                phone: "",
                email: "",
                message: ""
            },
            setTimeout(() => {
                this.errors.state_id = false;
                this.errors.city_id = false;
                this.errors.name = false;
                this.errors.lastname = false;
                this.errors.phone = false;
                this.errors.email = false;
                this.errors.message = false;
            }, 100);
        },
        getListStates() {
            var app = this;
            axios
                .get("api/getStates")
                .then(function (res) {
                    app.listDocuments = res.data.states;
                })
                .catch(function (err) {
                    console.log(err);
                });
        },
        getCities(id) {
            var app = this;
            var data = {
                stateId: id
            };
            axios
                .post("api/showCity", data)
                .then(function (res) {
                    app.showCities = false;
                    app.listCities = res.data.cities;
                })
                .catch(function (err) {
                    console.log(err);
                });
        },
        getTypeDocuments() {
            var app = this;
            axios
                .get("api/documentTypeController")
                .then(function (res) {
                    app.listTypeDocuments = res.data.TypeDocument;
                })
                .catch(function (err) {
                    console.log(err);
                });
        },
        validEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        validPhone(phone) {
            var re = /^[0-9]{7,10}$/;
            return re.test(phone);
        },
    },
    watch: {
        "form.message": function (n) {
            if (n) {
                this.errors.message = false;
            } else {
                this.errors.message = "El mensaje es requerido.";
            }
        },
        "form.name": function (n) {
            if (n) {
                this.errors.name = false;
            } else {
                this.errors.name = "Los nombres son requeridos.";
            }
        },
        "form.lastname": function (n) {
            if (n) {
                this.errors.lastname = false;
            } else {
                this.errors.lastname = "Los apellido son requeridos.";
            }
        },
        "form.phone": function (n) {
            if (!n) {
                this.errors.phone = "El teléfono es requerido.";
            } else if (!this.validPhone(n)) {
                this.errors.phone = "El teléfono es inválido.";
            } else {
                this.errors.phone = false;
            }
        },
        "form.email": function (n) {
            if (!n) {
                this.errors.email = "El email es requerido.";
            } else if (!this.validEmail(n)) {
                this.errors.email = "El email es inválido.";
            } else {
                this.errors.email = false;
            }
        },
        "form.state_id": function (n) {
            this.getCities(n);
            if (n == 0) {
                this.errors.state_id = "El departamento es requerido.";
            } else {
                this.errors.state_id = false;
            }
        },
        "form.city_id": function (n) {
            if (n != 0) {
                this.errors.city_id = false;
            } else {
                this.errors.city_id = "La ciudad es requerida.";
            }
        },
    },
    mounted() {
        this.getListStates();
    },
}
</script>

<style>
.color-input {
    font-size: 13px;
    background-color: #ffffff00 !important;
    height: 30px !important;
    color: #fff !important;
    position: relative;
    padding: 0.375rem 1.5rem !important;
}
.color-text {
    font-size: 13px;
    background-color: #ffffff00 !important;
    /* height: 30px !important; */
    color: #fff !important;
    position: relative;
    padding: 0.375rem 1.5rem !important;
}
.color-input:disabled {
    /* opacity: 0 !important; */
    border-color: #676565 !important;
    color: #676565 !important;
}
.color-text::placeholder {
    color: white !important;
}
.color-input::placeholder {
    color: white !important;
}
.color-option {
    color: black !important;
}
.info-contact {
    background-color: #FE0000;
    border-radius: 22px;
}
.text-info-contact {
    margin-bottom: .0rem;
    font-size: 17px;
}
.subtitle-contact {
    font-size: 22px;
    font-family: 'GothamBookItalic', sans-serif;
}
.img-etiqueta {
    width: 100px;
    height: 100px;
}
.title-contact {
    font-size: 50px;
    font-family: 'Gotham-UltraItalic', sans-serif;
    /* padding-bottom: 4%; */
}
.etiqueta {
    font-family: "GothamBookItalic", sans-serif;
}
.small-size {
    font-family: "GothamBookItalic", sans-serif !important;
}
.actual {
    padding-left: 20%;
    font-family: "GothamBoldItalic", sans-serif;
    font-size: 29px;
}
.oportunidades {
    font-size: 20px;
    font-family: "GothamBoldItalic", sans-serif;
    margin-bottom: 0rem !important;
}
.text-1-promo {
    text-align: left;
    font-size: 18px;
    margin-bottom: 0rem !important;
    padding-left: 20%;
    font-family: "GothamBookItalic", sans-serif;
}
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
    padding-right: 0px !important;
    padding-left: 0px !important;
}
.content-contact {
    padding-top: 10%;
    padding-bottom: 10%;
    height: 100%;
}
#content-contact-id {
    background-size: cover;
    background-image: url("./../../assets/img/FOTO-5.jpg");
    background-position: center center;
    background-attachment: fixed;
    background-color: "#171717";
}

@font-face {
    font-family: "ubuntu-bold";
    src: url("./../../assets/font/Ubuntu-Bold.ttf");
    font-display: swap;
}
@font-face {
    font-family: "Gotham-UltraItalic";
    src: url("./../../assets/font/Gotham-UltraItalic.ttf");
    font-display: swap;
}
@font-face {
    font-family: "GothamBoldItalic";
    src: url("./../../assets/font/GothamBoldItalic.ttf");
    font-display: swap;
}
@font-face {
    font-family: "GothamBookItalic";
    src: url("./../../assets/font/GothamBookItalic.ttf");
    font-display: swap;
}

/* MOBILE */
@media (max-width: 767px) {
    .participa {
        font-size: 40px;
        /* padding-bottom: 4%; */
    }
    .title-contact {
        font-size: 45px;
    }
    .subtitle-contact {
        font-size: 20px;
    }
    .info-contact {
        margin-top: 5%;
    }
    .content-contact {
        padding-top: 35%;
        padding-bottom: 12%;
        height: 100%;
    }
    .actual {
        padding-left: 0%;
        font-size: 25px;
        text-align: center !important;

    }
    .text-1-promo {
        text-align: center;
        font-size: 20px;
        padding-left: 0%;
    }
}
</style>